const mediaItems = [
  {
    title: '最新预告片合集',
    desc: '本月最值得期待的影视预告，抢先一睹为快',
    duration: '12:35',
    tag: '预告',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20trailer%20editing%20suite%20with%20timeline%20and%20film%20strips%2C%20warm%20professional%20lighting%2C%20director%20monitor%20displaying%20dramatic%20scene%2C%20creative%20post%20production%20environment%2C%20rich%20contrast%20with%20deep%20blacks%20and%20warm%20highlights%2C%20no%20people%2C%20editorial%20style&width=800&height=500&seq=media-trailer-2026&orientation=landscape',
  },
  {
    title: '幕后花絮全纪录',
    desc: '走进拍摄现场，揭秘热门剧集的台前幕后',
    duration: '18:22',
    tag: '花絮',
    image: 'https://readdy.ai/api/search-image?query=Film%20production%20set%20with%20professional%20camera%20equipment%20and%20director%20chair%2C%20warm%20studio%20lighting%2C%20behind%20the%20scenes%20cinematic%20atmosphere%2C%20vintage%20movie%20clapperboard%2C%20artistic%20documentary%20style%2C%20rich%20amber%20tones%2C%20no%20people%2C%20creative%20composition&width=800&height=500&seq=media-bts-2026&orientation=landscape',
  },
  {
    title: '深度影视解说',
    desc: '专业影评人带你解析剧情细节与隐藏彩蛋',
    duration: '25:10',
    tag: '解说',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20home%20theater%20setup%20with%20large%20screen%20displaying%20film%20analysis%20graphics%2C%20warm%20ambient%20lighting%2C%20notebook%20and%20pen%20for%20film%20review%20notes%2C%20cinematic%20viewing%20environment%2C%20soft%20golden%20glow%2C%20no%20people%2C%20intellectual%20aesthetic&width=800&height=500&seq=media-review-2026&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            精彩预告
          </h2>
          <p className="mt-3 text-sm text-foreground-500">最新影视预告、幕后花絮和专业解说</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {mediaItems.map((item) => (
            <div key={item.title} className="group cursor-pointer">
              <div className="relative rounded-xl overflow-hidden bg-background-100 aspect-video">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/10 group-hover:bg-black/20 transition-colors"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:bg-primary-600 transition-colors">
                    <i className="ri-play-fill text-2xl text-background-50 ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute top-3 right-3">
                  <span className="px-2.5 py-0.5 rounded-full bg-background-50/90 text-xs font-medium text-foreground-700">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="px-2 py-0.5 rounded bg-black/70 text-xs text-background-50">
                    {item.duration}
                  </span>
                </div>
              </div>
              <h3 className="mt-3 font-heading font-semibold text-base text-foreground-900 group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <p className="mt-1 text-xs text-foreground-500">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}